<script lang="ts" setup>
	useHead({
		title: "Fliq",
	});
</script>

<template>
	<main class="admin">
		<slot />
	</main>
</template>

<style scoped lang="scss">
	main.admin {
		width: 100%;
		height: 100%;
		padding-top: 112px;
		padding-bottom: 60px;
	}
</style>
